// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Forms_msaSection__k7mIT {\n  margin-top: 36px; }\n  .Forms_msaSection__k7mIT .Forms_statusFilter__3ua0L {\n    margin-left: 0;\n    flex: 1 1;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    line-height: 1; }\n\n.Forms_other__2tKx0 {\n  margin-top: 36px; }\n", ""]);
// Exports
exports.locals = {
	"msaSection": "Forms_msaSection__k7mIT",
	"statusFilter": "Forms_statusFilter__3ua0L",
	"other": "Forms_other__2tKx0"
};
module.exports = exports;
